<template>
  <div>
    <Modal v-model="modal" :title="!webWarningForm.id ? this.$t('alarms.network.AppService.addAppServiceAlertRule'):this.$t('alarms.network.AppService.updateAppServiceAlertRule')" @on-cancel="cancel" @on-ok="ok" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :footer-hide="true" :closable="false">
      <Form ref="webWarningForm" :model="webWarningForm" :label-width="110"
            :rules="ruleValidate">
        <!-- 下一步 -->
        <div v-show="isNext">
          <!-- 微信警告 -->
          <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
          <!-- 规则名称 -->
          <FormItem :label="this.$t('alarms.common.alertRuleName')" prop="ruleName" v-if="isEditRuleName">
            <Row>
              <Col span="11">
                <Input type="text" v-model="webWarningForm.ruleName" placeholder="Enter something..."
                       style="width:300px;" :disabled="isEdit"></Input>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则名称 -->
          <FormItem :label="this.$t('alarms.common.alertRuleName')" v-if="showRuleName">
            <Row>
              <Col span="24">
                <div>{{this.webWarningForm.ruleName}}</div>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则描述 -->
          <FormItem :label="this.$t('alarms.common.alertRuleDesc')">
            <Row :gutter="4">
              <!-- 监控指标 -->
              <Col span="4">
                <FormItem prop="monitorIndex">
                  <Select v-model="webWarningForm.monitorIndex"
                          filterable
                          @on-change="changeMonitorIndex(webWarningForm.monitorIndex)"
                          :placeholder="this.$t('alarms.common.monitorIndex')">
                    <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 周期 -->
              <Col span="3">
                <FormItem prop="cycle">
                  <Select v-model="webWarningForm.cycle"
                          filterable
                          @on-change="changeCycle(webWarningForm.cycle)"
                          :placeholder="this.$t('alarms.common.cycle')">
                    <Option :value="item.id" v-for="(item,index) in cycleList" :key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 连续周期 -->
              <Col span="4">
                <FormItem prop="continousCycle">
                  <Select v-model="webWarningForm.continousCycle"
                          filterable
                          @on-change="changeContinousCycle(webWarningForm.continousCycle)"
                          :placeholder="this.$t('alarms.common.continuous')">
                    <Option :value="item.id" v-for="(item,index) in continousCycleList" :key="index">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计数值 -->
              <Col span="4">
                <FormItem prop="statisticsValue">
                  <Select v-model="webWarningForm.statisticsValue"
                          filterable
                          @on-change="changeStatisticsValue(webWarningForm.statisticsValue)"
                          :placeholder="this.$t('alarms.common.statisticsValue')">
                    <Option :value="item.id" v-for="(item,index) in statisticsValueList" :key="index">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>

                <!-- 关系符号 -->
                <Col span="3">
                  <FormItem prop="relationshipSign">
                    <Select v-model="webWarningForm.relationshipSign"
                            filterable
                            @on-change="changeRelationshipSign(webWarningForm.relationshipSign)"
                            :placeholder="this.$t('alarms.common.sign')">
                      <Option :value="item.id" v-for="(item,index) in relationshipSignList" :key="index">
                        {{item.name}}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input v-model="webWarningForm.thresholdValue" :placeholder="this.$t('alarms.common.threshold')"
                           type="number"></Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input v-model="webWarningForm.unit" disabled :placeholder="this.$t('alarms.common.unit')"></Input>
                  </FormItem>
                </Col>
            </Row>
          </FormItem>

          <!-- 联系方式 -->
          <FormItem :label="this.$t('alarms.billing.contactWay')" prop="contactType">
              <RadioGroup v-model="webWarningForm.contactType" @on-change="changeContactType(webWarningForm.contactType)">
                  <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
              </RadioGroup>
          </FormItem>

          <!-- 通知对象 -->
          <FormItem :label="this.$t('alarms.common.contact')" prop="notificationObject"  v-if="webWarningForm.contactType==0">
            <Select v-model="webWarningForm.notificationObject" filterable multiple style="width:300px;" @on-change="changeNotificationObject"
                    :placeholder="this.$t('alarms.common.pleaseSelect')">
              <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 联系人组 -->
          <FormItem :label="this.$t('alarms.common.alertContactGroup')" prop="contactGroupIds" v-if="webWarningForm.contactType==1">
            <Select v-model="webWarningForm.contactGroupIds" filterable multiple style="width:300px;" @on-change="changeContactGroupId(webWarningForm.contactGroupIds)" :placeholder="this.$t('alarms.common.pleaseSelect')">
              <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 报警方式 -->
          <FormItem :label="this.$t('alarms.common.alarmType')" prop="noticeType">
            <Select v-model="webWarningForm.noticeType" filterable multiple style="width:300px;" @on-change="selectnoticeType(webWarningForm.noticeType)"
                    :placeholder="this.$t('alarms.common.pleaseSelect')">
              <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 企业微信机器人URL -->
          <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="webWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
            <Select v-model="webWarningForm.enterpriseWechatRobotIds" filterable multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
              <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 延迟告警 -->
          <FormItem :label="this.$t('alarms.common.delayAlarm')" prop="alarmDelay">
            <Select v-model="webWarningForm.alarmDelay" filterable style="width:300px;"
                    :placeholder="this.$t('alarms.common.pleaseSelect')">
              <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 监控时段 -->
          <FormItem :label="this.$t('alarms.common.monitoringTime')" prop="monitorPeriod">
            <Select v-model="webWarningForm.monitorPeriod" filterable style="width:300px;"
                    :placeholder="this.$t('alarms.common.pleaseSelect')">
              <Option v-for="item in monitorPeriodList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>

          <!-- 邮箱模板 -->
          <div v-show="isShowEmail">
            <FormItem :label="this.$t('alarms.common.emailTemplate')" prop="emailModal">
              <Input v-model="webWarningForm.emailModal" type="textarea"
                     :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
            </FormItem>
          </div>

          <!-- 企业微信模板 -->
          <div v-show="isShowWeChat">
            <FormItem :label="this.$t('alarms.common.weChatTemplate')" prop="wechatModal">
              <Input v-model="webWarningForm.wechatModal" type="textarea"
                     :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
            </FormItem>
          </div>
          <div style="height: 42px;">
            <Button type="primary" size="large" style="float: right;" @click="ok('webWarningForm')" :loading="addloading" :disabled="isAddOrEdit">
              {{!webWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}
            </Button>
            <Button size="large" style="float: right;margin-right: 10px;"
                    @click="cancel('webWarningForm')">{{ $t('alarms.common.cancel') }}
            </Button>
            <Button size="large" @click="previousPage" style="float: right;margin-right: 10px;">{{ $t('alarms.common.lastStep') }}</Button>
          </div>
        </div>

        <!-- 上一步 -->
        <div v-show="isPrevious">
          <div>
            <Row :gutter="16">
              <Col span="8">
                <!-- 账户 -->
                <FormItem :label="$t('alarms.common.account')" prop="account" :label-width="70">
                  <Select v-model="webWarningForm.account" filterable
                          @on-change="changeAccount(webWarningForm.account)" :transfer="true" placeholder="">
                    <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8" style="z-index: 200">
                <!-- 存储区域 -->
                <FormItem :label="$t('alarms.common.region')" prop="backupRegion">
                  <Select @on-change="changebackupRegion(webWarningForm.backupRegion)"
                          v-model="webWarningForm.backupRegion" filterable multiple :max-tag-count="1" :transfer="true" placeholder="">
                      <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                      <Option :value="item.name" v-for="item in backupRegionList" :key="item.id">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Button type="primary" style="float:right;" v-show="isShowSearch" @click="searchECDate">{{ $t('alarms.common.search') }}</Button>
            </Row>
          </div>

          <v-table :height="459" column-width-drag is-horizontal-resize
                   style="width:100%;height:459px;margin-bottom: 15px;" :columns="column" :table-data="tableWebDate"
                   row-hover-color="#edf7ff" :is-loading="modal_loadings" title-bg-color="#f8f8f9"
                   :select-group-change="selectChange" :select-all="selectAll"></v-table>
          <div style="height: 42px;">
            <Button type="primary" size="large" @click="nextPage" style="float: right;" :disabled="isNextClick">{{ $t('alarms.common.nextStep') }}
            </Button>
            <Button size="large" style="margin-right: 10px;float: right;" @click="cancel('webWarningForm')">{{ $t('alarms.common.cancel') }}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
    import WechatWarning from '../../common/WechatWarning.vue'
    import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'
    import TableWeb from '../web/TableWeb.vue'

    var tableWeb = TableWeb;
    var tableWebWarningVue = {}
    export default {
        inject: ['reload'],
        components: {
            WechatWarning
        },
        data() {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) => {
                var self = this;
                self.$api.alertRule.nameRepeatedCheck({
                    "alertRuleName": this.webWarningForm.ruleName,
                    "monitorModule": this.monitorModule
                })
                .then(res => {
                    if (res.status == 200) {
                        callback();
                    }
                })
                .catch(err => {
                    if (err.status == 400) {
                        callback(new Error('规则名称不能重复!'));
                    }
                })
            };
            return {
                monitorModule:24,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                    label: '联系人',
                    value: 'contact',
                    type: 0
                },
                {
                    label: '联系人组',
                    value: 'contactGroup',
                    type: 1
                }],
                addloading:false,
                singleBackupRegion:false,
                alarmDelayList:[],
                monitorPeriodList:[],
                isEdit: false,
                isShowSearch: false,
                isEditRuleName: false,
                showRuleName: false,
                modal_loadings: false,
                isShowEmail: false,
                isShowWeChat: false,
                isNext: false,
                isPrevious: true,
                selection: [],
                accountList: [],
                notificationObjectList: [],
                alarmWayList: [],
                backupRegionList: [],
                loading: true,
                modal: false,
                modal_loading: false,
                exportDataList: '',
                noticeType: [],
                units: '',
                isNextClick: true, //禁止点击下一步
                unit: '',
                webWarningForm: {
                    account: '',
                    ruleName: '',
                    notificationObject: [],
                    noticeType: [],
                    emailModal: '',
                    wechatModal: '',
                    thresholdValue: '',
                    monitorIndex: '',
                    cycle: '',
                    continousCycle: '',
                    statisticsValue: '',
                    relationshipSign: '',
                    unit: '',
                    backupRegion: [],
                    alarmDelay:'',
                    monitorPeriod:'',
                    contactType:0,
                    contactGroupIds:[],
                    userIdList:[],
                    enterpriseWechatRobotIds:[]
                },
                enterpriseWechatRobotIdsList:[],
                // 联系人组
                contactGroupIdList:[],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        {required: true, message: '请选择账户名称', trigger: 'change', type: 'number'}
                    ],
                    alarmDelay: [
                        {required: true, message: '请选择延迟告警', trigger: 'change', type: 'number'}
                    ],
                    monitorPeriod: [
                      {required: true, message: '请选择监控时段', trigger: 'change', type: 'number'}
                    ],
                    backupRegion: [
                        {required: true, type: 'array', message: '请选择存储区域', trigger: 'change'}
                    ],
                    ruleName: [
                        {required: true, message: '规则名称不能为空', trigger: 'blur'},
                        {type: 'string', message: '规则名称为2-20个字符首尾中间不能有空格', pattern: '^[^ ]{2,20}$', trigger: 'blur'},
                        {validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: '请选择通知对象', trigger: 'change'}
                    ],
                    noticeType: [
                        {required: true, type: 'array', min: 1, message: '请选择报警方式', trigger: 'change'}
                    ],
                    monitorIndex: [
                        {required: true, message: '请选择监控指标', trigger: 'change', type: 'number'}
                    ],
                    cycle: [
                        {required: true, message: '请选择周期', trigger: 'change', type: 'number'}
                    ],
                    continousCycle: [
                        {required: true, message: '请选择连续周期', trigger: 'change', type: 'number'}
                    ],
                    statisticsValue: [
                        {required: true, message: '请选择统计数值', trigger: 'change', type: 'number'}
                    ],
                    relationshipSign: [
                        {required: true, message: '请选择关系符号', trigger: 'change', type: 'number'}
                    ],
                    thresholdValue: [
                        {required: true, message: '请输入阈值'}
                    ],
                    contactType: [
                        {required: true, message: '请选择联系方式', trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: '请选择联系人组', trigger: 'change', type: 'array'}
                    ],
                    enterpriseWechatRobotIds: [
                      {required: true, type: 'array', message: '请选择企业微信机器人URL', trigger: 'change'}
                    ]
                },
                column: [
                    {
                        width: 60,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        type: 'selection'
                    },
                    {
                        field: 'name',
                        title: this.$t('alarms.network.AppService.name'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'state',
                        title: this.$t('alarms.network.AppService.status'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'resourceGroup',
                        title: this.$t('alarms.network.AppService.resourceGroup'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'region',
                        title: 'region',
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    }
                ],
                tableWebDate: [],
                newTableWebDateList: [],
                instanceList: [],
                compareResourceAzureAppServicesList:[]
            }
        },

        beforeCreate: function () {
            tableWebWarningVue = this
        },
        methods: {
            //显示表格数据
            /****************************************************************/
            // 下一步
            nextPage: function () {
                this.isNext = true;
                this.isPrevious = false;
                // 查询监控指标
                tableWebWarningVue.searchMonitorIndex();
                // 查询阈值
                tableWebWarningVue.selectMonitorIndexDefault();
                // 查询联系人组
                tableWebWarningVue.listContactGroups();
            },
            // 上一步
            previousPage: function () {
                this.isNext = false;
                this.isPrevious = true;
            },
            init: function (id) {
                this.webWarningForm.id = id || 0;
                // 根据用户名查询Account列表
                tableWebWarningVue.getAccount();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['webWarningForm'].resetFields();
                    // 编辑
                    if (this.webWarningForm.id) {
                        // 编辑显示不能输入的规则名称
                        this.showRuleName = true;
                        this.isEdit = true;
                        this.isShowSearch = false;
                        this.$api.alertRule.selectAlertRule("id", this.webWarningForm.id)
                            .then(res => {
                                //延时
                                this.webWarningForm.alarmDelay = res.data.delay;
                                //监控时段
                                this.webWarningForm.monitorPeriod = res.data.monitorPeriod;
                                // 账户
                                /******************************************************/
                                this.webWarningForm.account = res.data.accountId;
                                tableWebWarningVue.$api.account.queryAccountRegions("accountId", this.webWarningForm.account)
                                .then(res => {
                                    this.backupRegionList = res.data;
                                });

                              tableWebWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                                  "monitorModule":this.monitorModule,
                                  "accountId":this.webWarningForm.account
                                })
                                .then(res => {
                                  this.notificationObjectList = res.data.contactList;
                                });

                                this.modal_loadings = true;
                                setTimeout(() => {
                                    // 存储区域
                                    this.webWarningForm.backupRegion = res.data.regions;

                                    // 实例列表
                                    /******************************************************/
                                    this.instanceList = res.data.resourceAzureAppServicesList;
                                    this.compareResourceAzureAppServicesList=res.data.resourceAzureAppServicesList;
                                    // 根据AccountId查询Instance列表
                                    tableWebWarningVue.$api.resourceAzureAppService.queryAppService({
                                        "accountId": this.webWarningForm.account,
                                        "regions":this.webWarningForm.backupRegion
                                    })
                                    .then(res => {
                                        this.tableWebDate = res.data;
                                        this.modal_loadings = false;
                                        for (var i = 0; i < this.tableWebDate.length; i++) {
                                            for (var j = 0; j < this.compareResourceAzureAppServicesList.length; j++) {
                                                if (this.tableWebDate[i].name == this.compareResourceAzureAppServicesList[j].name) {
                                                    this.tableWebDate[i]._checked = true;
                                                }
                                            }
                                        }
                                        // 选了数据 可以点击下一步
                                        if (this.tableWebDate.length == 0 || this.compareResourceAzureAppServicesList.length == 0) {
                                            this.isNextClick = true;
                                        } else {
                                            this.isNextClick = false;
                                        }
                                    })
                                 }, 1000)

                                this.newTableWebDateList = res.data.resourceAzureAppServicesList;


                                // 规则名称
                                this.webWarningForm.ruleName = res.data.alertRuleName;

                                // 监控指标
                                /******************************************************/
                                this.webWarningForm.monitorIndex = res.data.monitorIndex;
                                // 周期
                                this.webWarningForm.cycle = res.data.cycle;
                                // 连续周期
                                this.webWarningForm.continousCycle = res.data.continousCycle;
                                // 统计数值
                                this.webWarningForm.statisticsValue = res.data.statisticsValue;
                                // 符号
                                this.webWarningForm.relationshipSign = res.data.relationshipSign;
                                // 阈值
                                this.webWarningForm.thresholdValue = res.data.thresholdValue;
                                // 单位
                                this.webWarningForm.unit = res.data.unit;
                                this.units = res.data.unitId;
                                // 企业微信机器人URL
                                this.webWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                                // 联系方式
                                this.webWarningForm.contactType = res.data.contactType;
                                if(res.data.contactType==0){
                                    // 通知对象
                                    this.webWarningForm.notificationObject = res.data.contactIDs;
                                    for(var i=0;i<this.webWarningForm.notificationObject.length;i++){
                                      for(var j=0;j<this.notificationObjectList.length;j++){
                                        if(this.webWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                                           this.webWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                        }
                                      }
                                    }
                                }else if(res.data.contactType==1){
                                    // 联系人组
                                    this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.webWarningForm.account)
                                    .then(res => {
                                        this.contactGroupIdList = res.data;
                                    })
                                    setTimeout(() => {
                                        this.webWarningForm.contactGroupIds = res.data.contactGroupIds;
                                    }, 1000)
                                }


                                // 报警方式
                                this.webWarningForm.noticeType = res.data.noticeType;

                                for (var i = 0; i < this.webWarningForm.noticeType.length; i++){

                                  if (this.webWarningForm.noticeType[i] == '0') {
                                    this.isShowEmail = true;
                                    this.webWarningForm.emailModal = res.data.briefReportBodyMail;
                                    this.noticeType = this.webWarningForm.noticeType;
                                    tableWebWarningVue.selectTemplate();
                                  }
                                  if (this.webWarningForm.noticeType[i] == '1') {
                                    // this.isShowWeChat = true;
                                    this.webWarningForm.wechatModal = res.data.briefReportBodyWechat;
                                    this.checkLeastOnePersonBoundWeChat();
                                    this.noticeType = this.webWarningForm.noticeType;
                                    tableWebWarningVue.selectTemplate();
                                  }else if(this.webWarningForm.noticeType[i]!='1'){
                                      this.wechatWarningVisible=false;
                                      this.isAddOrEdit=false;
                                  }

                                }
                            })
                    } else {
                        this.tableWebDate = [];
                        this.isEdit = false;
                        this.isShowSearch = true;
                        // 添加显示规则名称能输入
                        this.isEditRuleName = true;
                        this.showRuleName = false;
                    }
                })
                this.modal = true;
                this.isNext = false;
                this.isPrevious = true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function () {
                this.webWarningForm.cycle = '';
                this.webWarningForm.continousCycle = '';
                this.webWarningForm.statisticsValue = '';
                this.webWarningForm.relationshipSign = '';
                this.webWarningForm.thresholdValue = '';
            },
            isNotEmpty: function (obj) {
                if (typeof obj === "undefined" || obj === null || obj === "") {
                    return false;
                } else {
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function () {
                tableWebWarningVue.selectMonitorIndexDefault();
                this.unit = this.webWarningForm.monitorIndex;
                for (var i = 0; i < this.monitorIndexList.length; i++) {
                    if (this.monitorIndexList[i].id == this.unit) {
                        this.webWarningForm.unit = this.monitorIndexList[i].unit;
                        this.units = this.monitorIndexList[i].id;
                    }
                }
                tableWebWarningVue.selectTemplate();
                tableWebWarningVue.emptyDate();
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function () {
                if (this.webWarningForm.account == "" || this.webWarningForm.account == null) {
                    return;
                }
                tableWebWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.webWarningForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle": this.webWarningForm.cycle,
                    "continousCycle": this.webWarningForm.continousCycle,
                    "statisticsValue": this.webWarningForm.statisticsValue,
                    "relationshipSign": this.webWarningForm.relationshipSign,
                    "accountId": this.webWarningForm.account
                })
                .then(res => {
                    // 周期
                    this.cycleList = res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList = res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList = res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList = res.data.relationshipSignMap;
                    // 阈值
                    if (res.data.companyMonitoritemVariablesList.length == 1 && tableWebWarningVue.isNotEmpty(this.webWarningForm.cycle) && tableWebWarningVue.isNotEmpty(this.webWarningForm.continousCycle) && tableWebWarningVue.isNotEmpty(this.webWarningForm.statisticsValue) && tableWebWarningVue.isNotEmpty(this.webWarningForm.relationshipSign) && this.webWarningForm.id == 0) {
                        this.webWarningForm.thresholdValue = res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
                    }

                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function () {
                tableWebWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.webWarningForm.monitorIndex,
                    "relationshipSign": this.webWarningForm.relationshipSign,
                    "monitorModule": this.monitorModule,
                    "noticeType": this.webWarningForm.noticeType
                })
                .then(res => {
                    this.webWarningForm.wechatModal = res.data.briefReportBodyWechat;
                    this.webWarningForm.emailModal = res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectnoticeType: function () {
              this.isShowEmail = false;
              this.isShowWeChat = false;
              for(var i=0;i<this.webWarningForm.noticeType.length;i++) {
                if (this.webWarningForm.noticeType[i] == '0') {
                  this.isShowEmail = true;
                  this.noticeType = this.webWarningForm.noticeType;
                  tableWebWarningVue.selectTemplate();
                }
                if (this.webWarningForm.noticeType[i] == '1') {
                  // this.isShowWeChat = true;
                  this.noticeType = this.webWarningForm.noticeType;
                  this.checkLeastOnePersonBoundWeChat();
                  tableWebWarningVue.selectTemplate();
                }else if(this.webWarningForm.noticeType[i]!='1'){
                    this.wechatWarningVisible=false;
                    this.isAddOrEdit=false;
                }
              }
            },
            // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
              for(var i=0;i<this.webWarningForm.noticeType.length;i++){
                  if(this.webWarningForm.noticeType[i]==1){
                      var weChatDate={
                          "contactType":this.webWarningForm.contactType
                      };
                      // 联系方式为 -联系人-
                      if(this.webWarningForm.contactType==0){
                          weChatDate.userIds=this.webWarningForm.userIdList;
                      }
                      // 联系方式为 -联系人组-
                      else if(this.webWarningForm.contactType==1){
                          weChatDate.contactGroupIds = this.webWarningForm.contactGroupIds;
                      }
                      this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                      .then(res => {
                          if(res.data){
                            // 可以添加告警
                            this.wechatWarningVisible=false;
                            this.isAddOrEdit=false;
                          }else{
                            // 不可以添加微信告警
                            this.wechatWarningVisible=true;
                            this.isAddOrEdit=true;
                          }
                      })
                  }else if(this.webWarningForm.noticeType[i]!=1){
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                  }
              }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.webWarningForm.account)
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
               this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
              this.webWarningForm.userIdList=[];
              this.webWarningForm.notificationObject=val;
              for(var i=0;i<this.webWarningForm.notificationObject.length;i++){
                for(var j=0;j<this.notificationObjectList.length;j++){
                  if(this.webWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                     this.webWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                  }
                }
              }
              this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
              this.checkLeastOnePersonBoundWeChat();
            },
            //点击查询 加载全部数据
            /***********************************************************************************/
            searchECDate: function () {
                if (this.webWarningForm.account == "" || this.webWarningForm.account == null || this.webWarningForm.backupRegion == "" || this.webWarningForm.backupRegion == null) {
                    return;
                }
                this.modal_loadings = true;
                // 根据AccountId查询Instance列表
                tableWebWarningVue.$api.resourceAzureAppService.queryAppService({
                    "accountId": this.webWarningForm.account,
                    "regions":this.webWarningForm.backupRegion
                })
                .then(res => {
                    this.tableWebDate = res.data;
                    this.modal_loadings = false;
                })
            },

            /**************************************  查询  **************************************/
            // 查询监控指标
            searchMonitorIndex: function () {
                tableWebWarningVue.$api.alertRule.searchMonitorIndex({
                  "monitorModule":this.monitorModule,
                  "accountId":this.webWarningForm.account
                })
                .then(res => {
                    this.monitorIndexList = res.data;
                })
            },
            // 查询通知对象
            queryContacts: function () {
                tableWebWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                  "monitorModule":this.monitorModule,
                  "accountId":this.webWarningForm.account
                })
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.webWarningForm.notificationObject = res.data.defaultContactIds;
                })
            },
            // 查询报警方式
            alarmWay: function () {
                tableWebWarningVue.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmWayList = res.data;
              })
            },
             // 查询报警延迟
            getAlarmDelay: function () {
                tableWebWarningVue.$api.alertRule.alarmDelay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmDelayList = res.data;
              })
            },
          // 查询监控时间段
          searchMonitorPeriod: function(){
            this.$api.alertRule.monitorPeriod("userName",getCookie(global.cookieName))
              .then(res => {
                this.monitorPeriodList = res.data;
              })
          },
            // 周期
            changeCycle: function () {
                // 查询阈值
                tableWebWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function () {
                // 查询阈值
                tableWebWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function () {
                // 查询阈值
                tableWebWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function () {
                // 查询阈值
                tableWebWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableWebWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            getAccount: function () {
                // 清空表格
                this.tableWebDate = [];
                tableWebWarningVue.$api.account.selectAccountByCloudPlatform("type",2)
                .then(res => {
                    this.accountList = res.data;
                })
                // 查询方式
                tableWebWarningVue.alarmWay();
                 // 查询报警延时
                tableWebWarningVue.getAlarmDelay();
                //监控时段
                tableWebWarningVue.searchMonitorPeriod();
                // 监控模块查询关联的机器人列表
                tableWebWarningVue.listEnterpriseWechatRobotsByMonitorModule();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableWebWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                    "monitorModule":this.monitorModule
                })
                .then(res => {
                  this.enterpriseWechatRobotIdsList = res.data;
                })
            },
            // 选择账户
            changeAccount: function () {
                if (this.webWarningForm.account == "" || this.webWarningForm.account == null) {
                    return;
                }
                this.webWarningForm.backupRegion = '';
                // 清空表格
                this.tableWebDate = [];
                this.instanceList = [];
                this.isShowSearch = true;
                this.isNextClick = true;
                tableWebWarningVue.$api.account.queryAccountRegions("accountId", this.webWarningForm.account)
                .then(res => {
                    this.backupRegionList = res.data;
                });
                // 查询通知对象
                tableWebWarningVue.queryContacts();
                // 查询联系人组
                tableWebWarningVue.listContactGroups();
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.webWarningForm.backupRegion = []
                if (this.singleBackupRegion) {
                    this.backupRegionList.map((item) => {
                        this.webWarningForm.backupRegion.push(item.name)
                    })
                } else {
                    this.webWarningForm.backupRegion = []
                }
            },
            // 切换存储区域
            changebackupRegion: function (val) {
                if (val.length === this.backupRegionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
                // 表格数据为空、显示查询按钮、存储区域为空
                this.tableWebDate = [];
                this.instanceList = [];
                this.isShowSearch = true;
                this.isNextClick = true;
            },
            // 全选 单选
            /***********************************************************************************/
            // 单选
            selectChange(selection) {
                // 所有数据
                this.selection = selection;
                // 清空数组
                this.newTableWebDateList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var TableWebCopy = new Object();
                    TableWebCopy.name = this.selection[i].name;
                    TableWebCopy.accountId = this.selection[i].accountId;
                    TableWebCopy.region = this.selection[i].region;
                    TableWebCopy.state = this.selection[i].state;
                    TableWebCopy.resourceGroup = this.selection[i].resourceGroup;
                    TableWebCopy.type = this.selection[i].type;
                    TableWebCopy.serverFarm = this.selection[i].serverFarm;
                    this.newTableWebDateList.push(TableWebCopy);
                }
                // 选了数据 可以点击下一步
                if (this.newTableWebDateList.length == 0) {
                    this.isNextClick = true;
                } else {
                    this.isNextClick = false;
                }
            },
            // 全选
            selectAll: function (selection) {
                // 所有数据
                this.selection = selection;
                // 清空数组
                this.newTableWebDateList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    // 状态
                    var TableWebCopy = new Object();
                    TableWebCopy.name = this.selection[i].name;
                    TableWebCopy.accountId = this.selection[i].accountId;
                    TableWebCopy.region = this.selection[i].region;
                    TableWebCopy.state = this.selection[i].state;
                    TableWebCopy.resourceGroup = this.selection[i].resourceGroup;
                    TableWebCopy.type = this.selection[i].type;
                    TableWebCopy.serverFarm = this.selection[i].serverFarm;
                    this.newTableWebDateList.push(TableWebCopy);
                }
                if (this.selection.length == 0) {
                    this.isNextClick = true;
                } else {
                    this.isNextClick = false;
                }
            },
            // 创建添加或编辑报警
            /**********************************************************************************/
            ok: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var alertList = {
                            "alertRuleName": this.webWarningForm.ruleName,
                            "monitorIndex": this.webWarningForm.monitorIndex,
                            "cycle": this.webWarningForm.cycle,
                            "continousCycle": this.webWarningForm.continousCycle,
                            "statisticsValue": this.webWarningForm.statisticsValue,
                            "relationshipSign": this.webWarningForm.relationshipSign,
                            "accountId": this.webWarningForm.account,
                            "monitorModule": this.monitorModule,
                            "noticeType": this.webWarningForm.noticeType,
                            "unit": this.units,
                            "delay":this.webWarningForm.alarmDelay,
                            "monitorPeriod":this.webWarningForm.monitorPeriod,
                            "thresholdValue":this.webWarningForm.thresholdValue,
                            "contactType":this.webWarningForm.contactType,
                            "enterpriseWechatRobotIds":this.webWarningForm.enterpriseWechatRobotIds
                        };

                        // 如果联系方式是联系人 传通知对象
                        if(this.webWarningForm.contactType == 0){
                            alertList.contactIDs = this.webWarningForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.webWarningForm.contactType == 1){
                          alertList.contactGroupIds = this.webWarningForm.contactGroupIds;
                        }

                        if (this.webWarningForm.id > 0) {
                            alertList.id = this.webWarningForm.id;
                            alertList.resourceAzureAppServicesList = this.newTableWebDateList;
                            // 编辑告警
                            this.addloading=true;
                            tableWebWarningVue.$api.alertRule.updateAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.webWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success('编辑成功');
                                        // 禁止点击下一步
                                        this.isNextClick = true;
                                        this.isShowSearch = false;
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        } else {
                            // 添加告警
                            this.addloading=true;
                            alertList.resourceAzureAppServicesList = this.newTableWebDateList;
                            tableWebWarningVue.$api.alertRule.createAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        tableWeb.methods.showAll();
                                        this.webWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success('添加成功');
                                        // 禁止点击下一步
                                        this.isNextClick = true;
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        }
                    } else {
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if (this.webWarningForm.id > 0) {
                            this.$Message.error('编辑失败');
                        } else {
                            this.$Message.error('添加失败');
                        }
                    }
                });
            },
            // 取消
            cancel: function (name) {
                this.wechatWarningVisible=false;
                this.isAddOrEdit=true;
                this.isShowSearch = false;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.isNextClick = true;
                this.modal = false;
                this.$emit('on-cancel');
                this.webWarningForm.notificationObject = [];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                // 清空表格
                this.tableWebDate = [];
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/web/AddOrUpdateWebWarning.vue